import { UserLogin } from './../pages/user-login/user-login';
import { Component, Inject, Injector, OnDestroy } from '@angular/core';
import { Platform, LoadingController, App } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { Util } from './util';
import { HrLogin } from '../pages/hr_login/hr_login';
import { Dashboard } from '../pages/dashboard/dashboard';
import { SplashScreen } from '@ionic-native/splash-screen';
import { TranslateService } from '@ngx-translate/core';
import { Title } from '@angular/platform-browser';
import { DOCUMENT } from '@angular/common';
// import autoScroll from 'dom-autoscroller';


@Component({
  templateUrl: 'app.html'
})
export class MyApp extends Util {
  rootPage: any = UserLogin;
  theme_default = 'dark-theme_';
  link: HTMLLinkElement;
  linkx: HTMLLinkElement;
  linky: HTMLLinkElement;
  constructor(platform: Platform, public translate: TranslateService, statusBar: StatusBar, public app: App, injector: Injector, loading: LoadingController, splashScreen: SplashScreen,
    private titleService: Title, @Inject(DOCUMENT) private doc) {

    super(injector, loading);
    this.translate.addLangs(['en', 'it']);
    // console.log(this.translate.getLangs());
    // if(this.translate.getLangs().indexOf(this.translate.getBrowserLang()) != -1)
    //   this.translate.setDefaultLang(this.translate.getBrowserLang());
    // else
    //   this.translate.setDefaultLang('it');
    // console.log(this.translate.getBrowserLang());


    this.storage.get('language').then((lan) => {
      if (lan != undefined && lan != null && lan != '') {
        this.translate.setDefaultLang(lan);
      }
      else {
        let lanx = this.translate.getBrowserLang();
        if (lanx == 'it') {
          this.translate.setDefaultLang('it');
        }
        else {
          this.translate.setDefaultLang('en');
        }
      }
    })

    this.link = this.doc.createElement('link');
    this.link.setAttribute('rel', 'icon');
    this.link.setAttribute('type', 'image/x-icon');
    this.link.setAttribute('href', 'assets/icon/favicon.ico');
    this.doc.head.appendChild(this.link);




    platform.ready().then(() => {
      // Okay, so the platform is ready and our plugins are available.
      // Here you can do any higher level native things you might need. 

      platform.registerBackButtonAction(() => {
        // Catches the active view
        let nav = this.app.getActiveNavs()[0];
        let activeView = nav.getActive();
        // console.log(activeView.name);
        let currentRootPage = activeView.component;
        if (currentRootPage == Dashboard) {

          platform.exitApp();
        }
        else if (nav.canGoBack()) {
          nav.pop();
        }
      });



      if (platform.is('ios') || platform.is('android')) {
        // statusBar.backgroundColorByHexString('#ffffff');
        // statusBar.styleDefault();
        // statusBar.overlaysWebView(true);
        statusBar.backgroundColorByHexString('#000000');
        splashScreen.hide();

      }
      if (platform.is('ios')) {
        statusBar.overlaysWebView(false);
      }
    });
  }


  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    let url = document.URL;
    url = url.replace('http://', '');
    url = url.replace('https://', '');
    if (url.slice(0, 6) != 'yamapp') {
      this.linky = this.doc.createElement('link');
      this.linky.setAttribute('rel', 'manifest');
      this.linky.setAttribute('href', 'manifest.json');
      this.doc.head.appendChild(this.linky);
    }
    if (url.slice(0, 4) == 'desk') {
      // this.theme_default = 'eydlab-theme';
      this.etheme.set_config_theme('dark-theme_');
      this.rootPage = HrLogin;
    }
    if (url.slice(0, 8) == 'ejoydesk') {
      // this.theme_default = 'eydlab-theme';
      this.etheme.set_config_theme('ejoy-theme');
      this.rootPage = HrLogin;
    }
    else if (url.slice(0, 15) == 'app.coachfit.it') {
      this.etheme.set_config_theme('coachfit-theme');
      this.titleService.setTitle('CoachFit');
      this.link.setAttribute('href', 'assets/icon/faviconcoach.ico');
    }
    else if (url.slice(0, 3) == 'app') {
      // this.theme_default = 'dark-theme_';
      this.etheme.set_config_theme('dark-theme_');
    }
    else if (url.slice(0, 7) == 'classic') {
      // this.theme_default = 'eydlab-theme';
      this.etheme.set_config_theme('eydlab-theme');
    }
    else if (url.slice(0, 6) == 'safety') {
      // this.theme_default = 'safe-theme';
      this.etheme.set_config_theme('safe-theme');
    }
    else if (url.slice(0, 4) == 'gold')
      this.etheme.set_config_theme('havana-theme');

    else if (url.slice(0, 4) == 'ejoy')
      this.etheme.set_config_theme('ejoy-theme');

    else if (url.slice(0, 13) == 'noeformazione')
      this.etheme.set_config_theme('noeinglese-theme');

    // else if(url.slice(0,8) == 'coachfit')
    //   this.etheme.set_config_theme('coachfit-theme');

    else if (url.slice(0, 8) == 'galderma')
      this.etheme.set_config_theme('galderma-theme');
    else if (url.slice(0, 9) == 'viceversa')
      this.etheme.set_config_theme('viceversa-theme');
    else if (url.slice(0, 6) == 'withub')
      this.etheme.set_config_theme('withub-theme');
    else if (url.slice(0, 4) == 'demo')
      this.etheme.set_config_theme('demo-theme');
    else if (url.slice(0, 13) == 'primachemical')
      this.etheme.set_config_theme('primachemical-theme');
    else if (url.slice(0, 10) == 'coldiretti')
      this.etheme.set_config_theme('coldiretti-theme');
    else if (url.slice(0, 6) == 'yamapp') {
      this.linkx = this.doc.createElement('link');
      this.linkx.setAttribute('rel', 'apple-touch-icon');
      this.linkx.setAttribute('sizes', '180x180');
      this.linkx.setAttribute('href', 'assets/icon/faviconyamapp180.png');
      this.doc.head.appendChild(this.linkx);
      this.link.setAttribute('href', 'assets/icon/faviconyamapp.ico');
      this.titleService.setTitle('YamApp');
      this.etheme.set_config_theme('yamamay-theme');
      this.linky = this.doc.createElement('link');
      this.linky.setAttribute('rel', 'manifest');
      this.linky.setAttribute('href', 'manifestyamapp.json');
      this.doc.head.appendChild(this.linky);

    }
    else if (url.slice(0, 10) == 'bullappami')
      this.etheme.set_config_theme('bullappami-theme');
    else if (url.slice(0, 3) == 'sky')
      this.etheme.set_config_theme('sky-theme');
    else if (url.slice(0, 6) == 'mygame')
      this.etheme.set_config_theme('mygame-theme');
    else if (url.slice(0, 11) == 'privacygoal')
      this.etheme.set_config_theme('privacygoal-theme')
    else if (url.slice(0, 6) == 'trivio')
      this.etheme.set_config_theme('trivio-theme')
    else if (url.slice(0, 15) == 'mymicrotraining')
      this.etheme.set_config_theme('carrefour-theme')
    else if (url.slice(0, 9) == 'ilportico')
      this.etheme.set_config_theme('ilportico-theme')
    else if (url.slice(0, 11) == 'clericiauto')
      this.etheme.set_config_theme('clerici-theme') 
    else if (url.slice(0, 15) == 'ai.skilleyd.net') 
      this.etheme.set_config_theme('ai-theme');
    else
      this.etheme.set_config_theme(this.theme_default);
    // PER FARE I TEST DEI TEMI COMMENTARE QUESTA RIGA
    // this.etheme.set_config_theme('ai-theme'); 
    // this.etheme.set_config_theme('yamamay-theme'); 
    // this.etheme.set_config_theme('mygame-theme'); 
    // this.etheme.set_config_theme('ejoy-theme'); 
    // this.link.setAttribute('href', 'assets/icon/faviconcoach.ico');
    // this.titleService.setTitle('CoachFit');

  }
}




// WEBPACK FOOTER //
// ./src/app/app.component.ts